import { Controller } from "stimulus"

// Auto-refreshes the bulk-import preview when the coach changes a column
// mapping. Submits the form to its `formaction` (the preview route) so the
// server re-renders the parsed rows with the new mapping. The "Refresh
// preview" button stays available as a fallback for users without JS.
export default class extends Controller {
  static targets = ["refreshButton"]

  refresh() {
    if (this.hasRefreshButtonTarget) {
      this.refreshButtonTarget.click()
    } else {
      this.element.submit()
    }
  }
}
